import React, { forwardRef } from 'react';

import { Typography } from '@mui/material';
import { ChevronDown } from 'lucide-react';
import { makeStyles } from 'tss-react/mui';

import type { SelectButtonProps } from './SelectButton';
import { SelectButton } from './SelectButton';

interface DropdownSelectButtonProps extends Omit<SelectButtonProps, 'children' | 'labelClass'> {
  label: React.ReactNode;
  buttonVariant?: 'default' | 'dropdown';
  icon?: React.ReactNode;
}

const useStyles = makeStyles()(theme => ({
  button: {
    '&:active': {
      color: 'unset',
    },
    color: 'unset',
    height: 32,
  },
  label: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(0.5),
  },
}));

export const DropdownSelectButton = forwardRef(function DropdownSelectButton(
  { buttonVariant = 'dropdown', icon, label, ...props }: DropdownSelectButtonProps,
  ref: React.Ref<HTMLButtonElement>
) {
  const { classes } = useStyles();
  const labelContent =
    typeof label === 'string' || typeof label === 'number' ? (
      <Typography color="inherit" variant="subtitle2">
        {label}
      </Typography>
    ) : (
      label
    );

  return (
    <SelectButton ref={ref} className={classes.button} labelClass={classes.label} {...props}>
      {icon}
      {labelContent}
      {buttonVariant === 'dropdown' && <ChevronDown size={18} />}
    </SelectButton>
  );
});
